import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const sectionRoutes = ['products', 'model', 'media', 'technology', 'news', 'projects', 'about', 'contact']

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  ...sectionRoutes.map(section => ({
    path: `/${section}`,
    name: section,
    component: HomeView
  })),
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to) {
    const sectionId = to.path === '/' ? 'top' : to.path.slice(1)

    return new Promise(resolve => {
      Vue.nextTick(() => {
        window.requestAnimationFrame(() => {
          const section = document.getElementById(sectionId)
          const headerOffset = 76

          if (!section) {
            resolve({ x: 0, y: 0 })
            return
          }

          resolve({
            x: 0,
            y: Math.max(0, section.getBoundingClientRect().top + window.pageYOffset - headerOffset)
          })
        })
      })
    })
  }
})

export default router
